import { h, Component } from 'preact'
import post from '../../utils/post'
import Checkbox from '../../components/atoms/checkbox'

/* global window */

export default class PoliticianSection extends Component {
  render() {
    const { id, value, onChange } = this.props

    return typeof window !== 'undefined' &&
      typeof window.localStorage !== 'undefined' &&
      window.localStorage.password ? (
      <label>
        <span>Je poslanec </span>
        <Checkbox
          type="checkbox"
          onChange={evt => {
            console.log(evt)
            evt.preventDefault()
            post('/api/set-is-in-parliament', {
              password: window.localStorage.getItem('password'),
              id: Number.parseInt(id, 10),
              is_in_parliament: !value,
            })
              .then(({ ok }) => {
                if (ok) onChange(!value)
              })
              .catch(e => console.error(e))
          }}
          checked={value}
        />
      </label>
    ) : (
      <div />
    )
  }
}



// WEBPACK FOOTER //
// ./routes/politician/politician-is-mop.js